import { omit } from 'lodash';

import { CustomerMasterSourceType } from 'generated/bffFinancialInfo/models';
import { apiClient, ExtendedAxiosResponse } from 'helpers/apiClient';
import { ChannelType } from 'models/ChannelType';
import { Pagination } from 'models/Pagination';

export const api = {
  getBillingList: (
    url: string,
    filter: string,
    pagination: Pagination,
    subordinate?: boolean | undefined
  ): Promise<ExtendedAxiosResponse> =>
    apiClient.get(`${url}/financial-document/list`, {
      params: {
        customerMasterSource: CustomerMasterSourceType.O2POP,
        channel: ChannelType.MO2_CARE,
        filter,
        ...omit(pagination, ['initPages']),
        forceCheck: false,
        subordinate,
        sort: 'issueDate:desc',
      },
    }),

  getOpenBalanceList: (
    url: string,
    cuRefNo?: string,
    caRefNo?: string,
    subordinate?: boolean | undefined
  ): Promise<ExtendedAxiosResponse> =>
    apiClient.get(`${url}/open-balance/list`, {
      params: {
        channel: ChannelType.MO2_CARE,
        customerMasterSource: CustomerMasterSourceType.O2POP,
        forceCheck: false,
        cuRefNo,
        caRefNo,
        subordinate,
      },
    }),

  getCampaignList: (
    url: string,
    slotCode: string,
    cuRefNo?: string,
    campaignSourceSystem?: string,
    maxCountOfOffers?: number
  ): Promise<ExtendedAxiosResponse> =>
    apiClient.get(`${url}/campaign/list`, {
      params: {
        customerMasterSource: CustomerMasterSourceType.O2POP,
        channel: ChannelType.MO2_CARE,
        forceCheck: false,
        cuRefNo,
        slotCode,
        verifyACL: false,
        contextCuRefNo: cuRefNo,
        campaignSourceSystem,
        maxCountOfOffers,
      },
    }),

  postCampaignResponse: (
    url: string,
    audienceId?: string,
    audienceIdType?: string,
    treatmentCode?: string,
    campaignSourceSystem?: string,
    campaignId?: string,
    processingType?: string
  ): Promise<ExtendedAxiosResponse> =>
    apiClient.post(
      `${url}/campaign/responses`,
      {
        responseCode: 'OFFERED',
        audienceId,
        audienceIdType,
        treatmentCode,
        campaignSourceSystem,
        campaignId,
        processingType,
      },
      {
        params: {
          customerMasterSource: CustomerMasterSourceType.O2POP,
          channel: ChannelType.MO2_CARE,
        },
      }
    ),
};
